import { render, staticRenderFns } from "./UploaderForm.vue?vue&type=template&id=3c4bd948&scoped=true&"
import script from "./UploaderForm.vue?vue&type=script&lang=js&"
export * from "./UploaderForm.vue?vue&type=script&lang=js&"
import style0 from "./UploaderForm.vue?vue&type=style&index=0&id=3c4bd948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4bd948",
  null
  
)

export default component.exports